// extracted by mini-css-extract-plugin
export default {"auth":"auth_auth__XqBtq","tab":"auth_tab__PYYRs"};